module.exports = __webpack_public_path__ + "static/media/home_desktop.d624f487.jpg";